<goa-card alignItemsH="space-between" alignItemsV="center" cardSize="full">
  <goa-card-header>
    {{ hearingRequest?.action?.styleOfCause }}
  </goa-card-header>
  <goa-card-content>
      <jsg-single-row-panel
        first
        backgroundStyleClass="section-background-white"
      >
        <div first>
          <div>Justice</div>
          <div>{{ hearingRequest?.justice | incomplete }}</div>
        </div>
        <div second>
          <div>Hearing time (duration)</div>
          <div
            *ngIf="
              hearingRequest?.requestedHearingStartDate;
              else noHearingTime
            "
          >
            <div fxLayout="row" fxLayoutGap="{{ FlexLayoutType.Gap.Small }}">
              <div>
                {{ hearingRequest?.requestedHearingStartDate | date: 'h:mm a' }}
                -
                {{ hearingRequest?.requestedHearingEndDate | date: 'h:mm a' }}
                ({{ hearingRequest?.duration }} minutes)
              </div>
              <div
                *ngIf="
                  (hearingRequest?.hearingStatusCode == StatusType.Approved ||
                    hearingRequest?.hearingStatusCode == StatusType.Submitted ||
                    hearingRequest?.hearingStatusCode ==
                      StatusType.AdjournmentPending ||
                    hearingRequest?.hearingStatusCode ==
                      StatusType.AdjournmentSineDiePending) &&
                  showCalendarButton
                "
              >
                <a routerLink="{{ calendarRoute }}{{ hearingRequest?.id }}"
                  >View in calendar</a
                >
              </div>
            </div>
          </div>
          <ng-template #noHearingTime>
            <div>——</div>
          </ng-template>
        </div>
        <div third>
          <div>Varied deadlines</div>
          <div>
            {{ hearingRequest?.variedDeadlines ? 'Yes' : 'No' }}
          </div>
        </div>
      </jsg-single-row-panel>
    <div class="requirements-box">
      <jsg-single-row-panel backgroundStyleClass="section-background-white">
        <div first>
          <div>Hearing requirements</div>
          <div
            *ngIf="
              hearingRequest?.specialRequirementsSelection &&
                hearingRequest?.specialRequirementsSelection.length > 0;
              else noSpecialRequirementsBlock
            "
          >
            <div
              *ngFor="
                let requirement of hearingRequest?.specialRequirementsSelection
              "
            >
              <div>
                {{ requirement?.description }}
              </div>
            </div>
          </div>
          <ng-template #noSpecialRequirementsBlock> <div>——</div> </ng-template>
        </div>
        <div second>
          <div>Other</div>
          <div>{{ hearingRequest?.specialRequirementNotes | incomplete }}</div>
        </div>
      </jsg-single-row-panel>
    </div>
  </goa-card-content>
</goa-card>
